import { render, staticRenderFns } from "./ot-edit-contract-user.vue?vue&type=template&id=21d2234b&scoped=true&"
import script from "./ot-edit-contract-user.vue?vue&type=script&lang=ts&"
export * from "./ot-edit-contract-user.vue?vue&type=script&lang=ts&"
import style0 from "./ot-edit-contract-user.vue?vue&type=style&index=0&id=21d2234b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d2234b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VDivider,VForm,VOverlay})
